/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
interface AboutPageProps {
  themeMode: string
}

const AboutPage: FC<AboutPageProps> = ({ themeMode }) => (
  <>
    <div className="card h-100">
      <div className="card-body">
        <div className="d-flex flex-column justify-content-center  gap-2 mb-6 h-100">
          {/* <img
            src={`/media/logos/vampp-logo-${themeMode === 'light' ? 'dark' : 'white'}.png`}
            alt="logo"
            className="logo"
          />
          <p className="fw-bold fs-5 text-muted">Variant Analysis with Multiple Pathogenicity Predictors</p>
          <p className="fw-bold fs-5 text-muted text-center">
            VAMPP-score is a metascore for missense variant pathogenicity prediction. It utilizes 56 available in
            silico pathogenicity predictors (ISPPs) from dbNSFP(v4.9A) (<a href='https://pubmed.ncbi.nlm.nih.gov/21520341/' target='_blank' rel='noreferrer' > PMID: 21520341 </a>, <a href='https://pubmed.ncbi.nlm.nih.gov/33261662/' target='_blank' rel='noreferrer' >PMID: 33261662</a>) based on their
            performance in distinguishing and identifying three main variant groups (Pathogenic, Benign, and Unknown)
            based on ClinVar (<a href='https://pubmed.ncbi.nlm.nih.gov/31777943/' target='_blank' rel='noreferrer' >PMID: 31777943</a>) data.
          </p>
          <p className="fw-bold fs-5 text-muted text-center">
            If you use VAMPP-score or any component of our statistical framework in your work, please cite us: A New Era
            in Missense Variant Analysis: <br/> Statistical Insights and the Introduction of VAMPP-Score for Pathogenicity
            Assessment Eylul Aydin, Berk Ergun, Ozlem Akgun-Dogan, Yasemin Alanay, Ozden Hatirnaz Ng, Ozkan Ozdemir
            bioRxiv (2024.07.11.602867; doi:{" "}
            <a href="https://doi.org/10.1101/2024.07.11.602867" rel="noreferrer" target="_blank">
              https://doi.org/10.1101/2024.07.11.602867
            </a>
            )
          </p> */}
          <h1>What is VAMPP-score?</h1>
          <p>Missense variants, which alter protein structure and function, are fundamental to understanding the Mendeliome—the complete set of genes linked to Mendelian inheritance. Accurate interpretation of these variants is essential for genetic diagnostics, understanding their underlying mechanisms, and guiding patient management.</p>
          <p>Numerous in-silico pathogenicity predictors (ISPPs) have been developed for missense variant interpretation, but their predictions often suffer from inconsistency and limited reliability due to algorithmic biases, incomplete datasets, and annotation errors. These limitations frequently result in Variants of Uncertain Significance (VUS)—variants with clinically relevant phenotypic implications but insufficient evidence to confirm pathogenicity. This diagnostic uncertainty underscores the need for standardized, integrated approaches that improve upon existing tools.</p>
          <p>To address this, we developed the Variant Analysis with Multiple Pathogenicity Predictors-score (VAMPP-score), a novel statistical framework designed to enhance missense variant interpretation. Unlike traditional ISPPs, VAMPP-score is a flexible framework that integrates the most accurate ISPPs for each gene, combining their predictions through weighted scoring, statistical analysis, and the proximity between variant group distributions. Its adaptable design allows optimization for other datasets, enabling broader application across different variants and genomic contexts.</p>
          <img
            src={`/vampp-about.png`}
            alt="logo"
            width={700}
            style={{
              margin: 'auto',
            }}
          />
          <p>
            VAMPP-score utilizes in silico pathogenicity predictors (ISPPs) available in dbNSFP(v4.9A) (PMID:  <a href='https://pubmed.ncbi.nlm.nih.gov/21520341/' target='_blank' rel='noreferrer'>21520341 </a> , PMID:  <a href='https://pubmed.ncbi.nlm.nih.gov/33261662/' target='_blank' rel='noreferrer'>33261662</a>) based on their performance in distinguishing and identifying three main variant groups (Pathogenic, Benign, and Unknown) from ClinVar (PMID: <a href='https://pubmed.ncbi.nlm.nih.gov/31777943/' target='_blank' rel='noreferrer'>31777943</a>).
          </p>
          <h2> Citation</h2>
          <p>
            If you use VAMPP-score or any component of our statistical framework in your work, please cite us:
            A New Era in Missense Variant Analysis: Statistical Insights and the Introduction of VAMPP-Score for Pathogenicity Assessment Eylul Aydin, Berk Ergun, Ozlem Akgun-Dogan, Yasemin Alanay, Ozden Hatirnaz Ng, Ozkan Ozdemir bioRxiv (2024.07.11.602867; doi: <a href='https://doi.org/10.1101/2024.07.11.602867' rel='noreferrer' target='_blank'>https://doi.org/10.1101/2024.07.11.602867</a>)
          </p>
        </div>

      </div>
    </div>
  </>
)

const AboutPageWrapper: FC = () => {
  const [themeMode, setThemeMode] = useState<string>('light')

  useEffect(() => {
    const currentTheme = document.documentElement.getAttribute('data-bs-theme')
    setThemeMode(currentTheme === 'light' ? 'light' : 'dark')

    const observer = new MutationObserver(() => {
      const updatedTheme = document.documentElement.getAttribute('data-bs-theme')
      setThemeMode(updatedTheme === 'light' ? 'light' : 'dark')
    })

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] })

    return () => observer.disconnect()
  }, [])
  const sampleData = [
    { category: "A", value: 10 },
    { category: "A", value: 15 },
    { category: "B", value: 20 },
    { category: "B", value: 25 },
    { category: "C", value: 30 },
    { category: "C", value: 35 },
  ];
  return (
    <>
      <AboutPage themeMode={themeMode} />
    </>
  )
}

export { AboutPageWrapper }
